"use client";

import { Minus, Plus } from "lucide-react";

import { t } from "@/lib/localization";
import { WordCloudBlock } from "@/lib/utils/lomdaV3/types";
import { useLomdaV3Editor } from "../../store/useLomdaV3Editor";
import { ToolbarDivider, WidthControl } from "./blockAppearance";

const MIN_WORDS = 1;
const MAX_WORDS = 5;

/** Topbar for the word cloud: width + the number-of-words stepper. */
export default function WordCloudSettings({ block }: { block: WordCloudBlock }) {
    const replaceBlockData = useLomdaV3Editor((s) => s.replaceBlockData);
    const { wordCount } = block.data;
    const setCount = (n: number) =>
        replaceBlockData(block.id, { ...block.data, wordCount: n });

    return (
        <div className="flex items-center gap-3">
            <WidthControl blockId={block.id} />
            <ToolbarDivider />
            <div className="flex shrink-0 items-center gap-2">
                <span className="whitespace-nowrap text-sm text-foreground">
                    {t("lomda-v3-editor.word-cloud.word-count")}
                </span>
                <div className="flex h-9 items-center rounded-lg border border-border">
                    <button
                        type="button"
                        disabled={wordCount <= MIN_WORDS}
                        onClick={() => setCount(wordCount - 1)}
                        className="flex size-8 items-center justify-center rounded-s-lg text-muted-foreground transition hover:bg-accent disabled:opacity-30"
                    >
                        <Minus className="size-4" />
                    </button>
                    <span className="w-8 text-center text-sm text-foreground">
                        {wordCount}
                    </span>
                    <button
                        type="button"
                        disabled={wordCount >= MAX_WORDS}
                        onClick={() => setCount(wordCount + 1)}
                        className="flex size-8 items-center justify-center rounded-e-lg text-muted-foreground transition hover:bg-accent disabled:opacity-30"
                    >
                        <Plus className="size-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
